import { render, staticRenderFns } from "./MessageListWidget.vue?vue&type=template&id=1711483a&"
import script from "./MessageListWidget.vue?vue&type=script&lang=js&"
export * from "./MessageListWidget.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports